// @flow
import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';

import { CheckoutButton } from 'app/common/layouts/commonShop';
import Add2CartModal from 'app/common/components/Shop/Cart/Add2CartModal';
// $FlowFixMe
import { add2cart } from 'app/common/actions/shop/cart/add2cart';

import selectNumberInCart from './selectNumberInCart';


type Props = {
  productId: number,
}

const Add2CartButton = ({ productId }: Props) => {
  const dispatch = useDispatch();

  // окно добавления
  const [showAdd2Cart, setShowAdd2Cart] = useState(false);
  const handleAdd2Cart = useCallback(async (e) => {
    e.preventDefault();
    const res = await dispatch(add2cart(productId, 1));
    if (res) {
      setShowAdd2Cart(true);
    }
  }, [dispatch, productId]);
  const handleCloseModal = useCallback((e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    setShowAdd2Cart(false);
  }, []);

  const adding = useSelector(state => state.shop.cart.adding, shallowEqual);

  const numberInCart = useSelector(state => selectNumberInCart(state, { productId }));

  return (
    <React.Fragment>
      {numberInCart
        ? <CheckoutButton to="/shop/cart">{'Перейти в корзину'}</CheckoutButton>
        : <CheckoutButton onClick={handleAdd2Cart} disabled={adding}>
          {adding ? 'Добавление...' : 'В корзину'}
        </CheckoutButton>}
      {showAdd2Cart
        && <Add2CartModal
          onClose={handleCloseModal}
          productId={productId}
          onDeleteProduct={handleCloseModal}
        />}
    </React.Fragment>
  );
};

export default Add2CartButton;
